import demo from './modules/demo';
import refund from './modules/refund';
import index from './modules/index';
import complaint from './modules/complaint';
import travel from './modules/travel';
import appraise from './modules/appraise';
import resourcesManage from './modules/resourcesManage';
import feedback from './modules/feedback';

import appraiseNew from './modules/appraiseNew';

import operate from './modules/operate';
import integrity from './modules/integrity';
import guide from './modules/guide';
import message from './modules/message';
import common from './modules/common';
import investment from './modules/investment';
export * from './modules/itineraryUniversal';
export * from './modules/privacy'

// 重新组织后导出
export default {
  ...demo,
  ...refund,
  ...index,
  ...complaint,
  ...travel,
  ...appraise,
  ...operate,
  ...integrity,
  ...guide,
  ...message,
  ...common,
  ...appraiseNew,
  ...resourcesManage,
  ...investment
};
